import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.jsx'
import { LanguageProvider } from './i18n'
import './index.css'
import './utils/scrollActivity' // Dark mode scrollbar "scroll-to-see" tracking (#192)
import { applyEntryLanding } from './utils/entryLanding'

// Opening the app (a new tab at the bare address) lands on the Main Page (#512).
applyEntryLanding()

ReactDOM.createRoot(document.getElementById('root')).render(
    <React.StrictMode>
        <LanguageProvider>
            <App />
        </LanguageProvider>
    </React.StrictMode>,
)
